import ApiService from "../../../services/ApiService";

function firstHttpUrl(...values) {
    for (const value of values) {
        if (typeof value === "string" && value.trim().startsWith("http")) {
            return value.trim();
        }
    }
    return "";
}

function pickStandaloneImageUrl(record) {
    if (!record || typeof record !== "object") return "";
    const story = record.story && typeof record.story === "object" ? record.story : null;
    if (story && (story.standaloneImage === true || story.standalone_image === true)) {
        const standalone = firstHttpUrl(
            story.imageUrl,
            story.image_url,
            story.imagePreviewUrl,
            story.image_preview_url,
        );
        if (standalone) return standalone;
    }
    return firstHttpUrl(
        record.imageUrl,
        record.image_url,
        story?.imageUrl,
        story?.image_url,
        record.imagePreviewUrl,
        record.image_preview_url,
        story?.imagePreviewUrl,
    );
}

/**
 * Screenshot card photo from a published sliding or jigsaw id.
 * Standalone packs have no crossword template, so the story id is not a public image key.
 */
export async function resolveStandaloneBackgroundUrl({ slidingId, jigsawId } = {}) {
    const tries = [];
    const sliding = typeof slidingId === "string" ? slidingId.trim() : "";
    const jigsaw = typeof jigsawId === "string" ? jigsawId.trim() : "";
    if (sliding) tries.push(`/home/sliding/${encodeURIComponent(sliding)}`);
    if (jigsaw) tries.push(`/home/jigsaw/${encodeURIComponent(jigsaw)}`);
    for (const path of tries) {
        try {
            const raw = await ApiService.getData(path);
            const url = pickStandaloneImageUrl(raw) || pickStandaloneImageUrl(raw?.data);
            if (url) return url;
        } catch {
            /* try the next puzzle id */
        }
    }
    return "";
}
